import React from "react";
import { format, parseISO } from "date-fns/esm";

const TripDates = ({ data, t }) => {
  return (
    <div className="grid grid-cols-2 gap-1 border border-slate-200 border-t-0 border-l-0 border-r-0 my-2 pb-1">
      <div className="flex flex-col">
        <div className="flex">
          <p className="font-[Gravity] font-bold mr-1">
            {t("monitoringTrips.start_date")}
          </p>
        </div>
        <div className="flex">
          <p className="font-[Gravity] font-bold mr-1">
            {t("monitoringTrips.end_date")}
          </p>
        </div>
      </div>
      <div className="flex flex-col">
        <div className="flex">
          <p className="font-[Gravity] font-bold mr-1">
            {t("monitoringTrips.start_date_real")}
          </p>
          <p className="font-[Gravity]">
            {data.startTrip && format(
              parseISO(data?.startTrip),
              "dd/MM/yyyy HH:mm"
            )}
          </p>
        </div>
        <div className="flex">
          <p className="font-[Gravity] font-bold mr-1">
            {t("monitoringTrips.end_date_real")}
          </p>
          <p className="font-[Gravity]">
            {data.endTrip && format(
              parseISO(data?.endTrip),
              "dd/MM/yyyy HH:mm"
            ) !== "01/01/0001 00:00" && format(
              parseISO(data?.endTrip),
              "dd/MM/yyyy HH:mm"
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TripDates;
